import { createRootRoute, HeadContent, Outlet, useLocation } from '@tanstack/react-router';
import React, { useEffect } from 'react';

import { I18nProvider, useTranslation } from '~/app';
import { reportRouteUpdate } from '~/app/clientBootstrap';
import { getRouteHead } from '~/app/routeHead';

import { RootRouteError } from './-RootRouteError';

function LangSync() {
  const { locale } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);
  return null;
}

function RootLayout() {
  const location = useLocation();

  useEffect(() => {
    const pathname = String(location.pathname ?? '');
    const search = typeof location.search === 'string' ? location.search : '';
    const hash = typeof location.hash === 'string' ? location.hash : '';
    reportRouteUpdate({ pathname, search, hash });
  }, [location.pathname, location.search, location.hash]);

  return (
    <>
      <HeadContent />
      <I18nProvider urlPath={location.pathname}>
        <LangSync />
        <Outlet />
      </I18nProvider>
    </>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
  errorComponent: RootRouteError,
  head: () => getRouteHead({}),
});
